module.exports = __webpack_public_path__ + "static/media/Garage2.c92f018f.jpg";